import app from 'flarum/common/app';

/**
 * The status label for a user, e.g. "39 haftalık hamile" or "Gebelik planlıyor".
 *
 * The server only sends a status it has already validated (week range, stale
 * due dates), so anything else here simply means "show nothing".
 *
 * @param {User} user
 * @returns {string|Array} empty string when no label should be shown.
 */
export default function formatPregnancyStatus(user) {
  if (!user || !user.pregnancyStatus) return '';

  const status = user.pregnancyStatus();

  if (status === 'pregnant') {
    const week = user.pregnancyWeek();

    if (typeof week !== 'number' || week < 1) return '';

    return app.translator.trans('happydigital-pregnancy.lib.pregnant_weeks', { count: week });
  }

  if (status === 'planning') {
    return app.translator.trans('happydigital-pregnancy.lib.planning');
  }

  return '';
}
